import Vue from 'vue'
import App from './App.vue'
import router from './plugins/router'
import vuetify from './plugins/vuetify'
import store from './store/index'
import filters from './plugins/filters'

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App),
  router,
  store,
  filters
}).$mount('#app')
